export default __webpack_public_path__ + "static/Japan-fbfe38116a578867d21bb32019313fe7.png";